import { render, staticRenderFns } from "./LmNicho.vue?vue&type=template&id=2b8e0d4e&"
import script from "./LmNicho.vue?vue&type=script&lang=js&"
export * from "./LmNicho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports